import React, { Component } from 'react';
import 'App.css';
import { Route, withRouter } from 'react-router-dom';
import { connect } from 'react-redux'; // eslint-disable-line no-unused-vars

import common from '~/common';
import Page_Login from '~/containers/Page_Login';
import Page_Main from '~/containers/Page_Main';
import Page_Gis from '~/containers/Page_Gis';
import Background_Execution from '~/containers/Background_Execution';

class App extends Component {
  render () {
    const { session = {} } = this.props;
    return (
      <div id="app" className="App">
        <div id="main" style={{ width: '100%', height: '100%', minWidth: 1350, minHeight: 700, position: 'relative' }}>
          <Route path='/' component={Background_Execution} />
          <Route path={`${common.rootPath}/Login`} component={Page_Login} />
          <Route path={`${common.rootPath}/Manage/Login`} component={Page_Login} />
          {Object.keys(session).length > 0 && <Route path={`${common.rootPath}/Manage/Main`} component={Page_Main} />}
          {Object.keys(session).length > 0 && <Route path={`${common.rootPath}/Gis`} component={Page_Gis} />}
        </div>
      </div>
    );
  }
}
const mapStateToProps = state => ({
  session: state.session,
});
const mapDispatchToProps = dispatch => ({
});
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));
